import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = sessionStorage.getItem('token'); // Assuming token is stored in sessionStorage

  return token ? children : <Navigate to="/" />;
  //  return token ? children :  window.location.href = '/login';
};

export default PrivateRoute;